import { component as defineComponent } from 'flightjs';

function watchButton() {
    this.attributes({
        buttonLabel: '[data-button-label]'
    });

    this.after('initialize', function () {
        this.on('click', this.toggleWatch);
        this.on(document, 'dataNdaSigned', this.watchContest);
    });

    this.getWatchActionData = function () {
        return {
            watchingText: this.$node.attr('data-watching-text'),
            watchText: this.$node.attr('data-watch-text'),
            unwatchUrl: this.$node.attr('data-unwatch-url'),
            watchUrl: this.$node.attr('data-watch-url')
        };
    };

    this.showWatching = function (watchData) {
        this.$node.attr('data-button-selected', true);
        this.select('buttonLabel').text(watchData.watchingText);
    };

    this.showWatch = function (watchData) {
        this.$node.removeAttr('data-button-selected');
        this.select('buttonLabel').text(watchData.watchText);
    };

    this.watch = function () {
        var watchData = this.getWatchActionData();

        this.showWatching(watchData);
        $.post(watchData.watchUrl).fail(
            function () {
                this.showWatch(watchData);
            }.bind(this)
        );
    };

    this.unwatch = function () {
        var watchData = this.getWatchActionData();

        this.showWatch(watchData);
        $.post(watchData.unwatchUrl).fail(
            function () {
                this.showWatching(watchData);
            }.bind(this)
        );
    };

    this.toggleWatch = function (e) {
        e.preventDefault();

        if (this.$node.is('[data-button-selected]')) {
            this.unwatch();
        } else {
            if (this.$node.is('[data-nda-required]')) {
                this.trigger(
                    'uiWatchNdaContestRequested',
                    {
                        listingId: this.$node.attr('data-listing-id'),
                        contentUrl: this.$node.attr('data-nda-content-url'),
                        acceptUrl: this.$node.attr('data-nda-accept-url')
                    }
                );
            } else {
                this.watch();
            }
        }
    };

    this.watchContest = function (e, data){
        if (this.$node.attr('data-listing-id') === data.listingId) {
            this.$node.removeAttr('data-nda-required');
            this.watch();
        }
    };
}

export default defineComponent(watchButton);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/watch-button.js